import { useContext } from "react";
import { UserProgramContext } from "../context/user-program/user-program";
import { tokenSignOut } from "../api/auth";
import { useNavigate } from "react-router-dom";
import { ROUTE_HOME, SUBROUTE_SIGN_IN } from "../constants";

export const useSignOut = () => {
  const { setUnauthorized } = useContext(UserProgramContext);

  const navigate = useNavigate();

  const signOut = () => {
    tokenSignOut().then(() => {
      setUnauthorized(true);
      navigate(`${ROUTE_HOME}${SUBROUTE_SIGN_IN}`);
    });
  };

  return { signOut };
};
